export default __webpack_public_path__ + "static/boom-14a43d542f877c0ca965020994643713.png";